import { connect } from 'react-redux'
import { getMedia } from '../actions/media'
import VCGallery from '../components/VCGallery'

const mapStateToProps = (state) => ({
  media: state.entities.media,
})

const mapDispatchToProps = {
  getMedia
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VCGallery)


// WEBPACK FOOTER //
// ./src/containers/VCGallery.js